import SubscriptionTopicModel from 'cio/models/subscription-topic';
import { SerializedLegacyAttributeFilter, SerializedLegacyFilter } from 'cio/types/conditions/legacy-filter';
import { CIO_SUBSCRIPTION_PREF_KEY } from 'cio/utils/attributes';

export function getSubscriptionTopicLegacyFilters(
  conditions: SerializedLegacyFilter[] | null,
  subscriptionTopic: SubscriptionTopicModel | null,
  subscriptionCenterEnabled: boolean,
) {
  // If the subscription center is disabled but a topic is selected, the message
  // will still be sent to all people until the subscription center is enabled
  if (subscriptionTopic == null || subscriptionCenterEnabled === false) {
    return conditions;
  }

  let conditionsWithTopic = conditions ?? [];
  let subscriptionTopicCondition: SerializedLegacyAttributeFilter;

  // Opt-in topics are those which require end-users to subscribe to that topic.
  // For this filter, that means that profiles will need to have the profile
  // attribute set to `true`. For opt-out topics, profiles will receive messages
  // only if the user has explicitly unsubscribed from the topic.
  if (subscriptionTopic.optIn) {
    subscriptionTopicCondition = {
      type: 'attribute',
      field: `${CIO_SUBSCRIPTION_PREF_KEY}.topics.topic_${subscriptionTopic.id}`,
      operator: 'eq',
      value: 'true',
    };
  } else {
    subscriptionTopicCondition = {
      type: 'attribute',
      field: `${CIO_SUBSCRIPTION_PREF_KEY}.topics.topic_${subscriptionTopic.id}`,
      operator: '!eq',
      value: 'false',
    };
  }

  return [...conditionsWithTopic, subscriptionTopicCondition];
}
